<div class="space-y-6">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Messages</h1>
      <p class="text-gray-600 mt-1">Patient communications and notifications</p>
    </div>
    <app-button variant="primary">
      <svg class="w-4 h-4 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      New Message
    </app-button>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <!-- Messages List -->
    <div class="lg:col-span-1 card">
      <div class="mb-4">
        <app-input
          type="text"
          [ngModel]="searchQuery()"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Search messages...">
        </app-input>
      </div>
      <div class="space-y-2 max-h-[600px] overflow-y-auto">
        @if (filteredMessages().length === 0) {
          <p class="text-gray-500 text-center py-8 text-sm">No messages found</p>
        } @else {
          @for (message of filteredMessages(); track message.id) {
            <div
              (click)="selectMessage(message)"
              class="p-4 rounded-lg border cursor-pointer transition-all duration-200"
              [ngClass]="{
                'bg-primary-50 border-primary-200': selectedMessage()?.id === message.id,
                'bg-white border-gray-200 hover:border-primary-300': selectedMessage()?.id !== message.id,
                'bg-blue-50 border-blue-200': !message.read
              }">
              <div class="flex items-start justify-between mb-2">
                <div class="flex-1 min-w-0">
                  <p class="font-semibold text-gray-900 text-sm truncate">{{ message.fromName }}</p>
                  <p class="text-xs text-gray-500">{{ message.date | date:'short' }}</p>
                </div>
                @if (!message.read) {
                  <span class="w-2 h-2 bg-primary-600 rounded-full flex-shrink-0 mt-1"></span>
                }
              </div>
              <p class="text-sm font-medium text-gray-900 mb-1">{{ message.subject }}</p>
              <p class="text-xs text-gray-600 line-clamp-2">{{ message.message }}</p>
              <span class="inline-block mt-2 badge"
                    [ngClass]="{
                      'badge-primary': message.type === 'appointment',
                      'badge-success': message.type === 'prescription',
                      'badge-warning': message.type === 'billing',
                      'badge-info': message.type === 'general'
                    }">
                {{ message.type }}
              </span>
            </div>
          }
        }
      </div>
    </div>

    <!-- Message Detail -->
    <div class="lg:col-span-2 card">
      @if (!selectedMessage()) {
        <div class="text-center py-16">
          <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          <p class="text-gray-500">Select a message to view details</p>
        </div>
      } @else {
        <div class="space-y-4">
          <div class="flex items-center justify-between pb-4 border-b">
            <div>
              <h3 class="text-xl font-semibold text-gray-900">{{ selectedMessage()!.subject }}</h3>
              <p class="text-sm text-gray-500 mt-1">
                From: {{ selectedMessage()!.fromName }} • {{ selectedMessage()!.date | date:'medium' }}
              </p>
            </div>
            <span class="badge"
                  [ngClass]="{
                    'badge-primary': selectedMessage()!.type === 'appointment',
                    'badge-success': selectedMessage()!.type === 'prescription',
                    'badge-warning': selectedMessage()!.type === 'billing',
                    'badge-info': selectedMessage()!.type === 'general'
                  }">
              {{ selectedMessage()!.type }}
            </span>
          </div>
          <div class="prose max-w-none">
            <p class="text-gray-700 leading-relaxed whitespace-pre-wrap">{{ selectedMessage()!.message }}</p>
          </div>
          <div class="pt-4 border-t flex space-x-3">
            <app-button variant="primary">Reply</app-button>
            <app-button variant="secondary">Forward</app-button>
            <app-button variant="danger">Delete</app-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>

